module.exports = __webpack_public_path__ + "img/custom.3d2b444d.png";